import { Box, Typography } from "@mui/material";
import { PublicMenuItem } from "src/data/publicMenu/queries/publicMenu";
import { colorPublicMenuAccent, colorPublicMenuText } from "src/design/tokens";
import { MenuItemRow } from "./MenuItemRow";

interface MenuSectionProps {
  id: string;
  title: string;
  items: PublicMenuItem[];
  // Optional decorative eyebrow shown above the title.
  eyebrow?: string;
}

// One menu section: an accent ornament, an optional eyebrow, the serif section
// title, and its list of items. `id` is the scroll target for the category nav.
export const MenuSection = ({ id, title, items, eyebrow }: MenuSectionProps) => (
  <Box
    id={id}
    sx={{
      // Keep the title clear of the sticky header + category nav on scroll-to.
      scrollMarginTop: "140px",
      mb: { xs: 5, md: 8 },
    }}
  >
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      <Box
        sx={{
          width: 32,
          height: 2,
          backgroundColor: colorPublicMenuAccent,
          mb: 2,
        }}
      />
      {eyebrow && (
        <Typography
          sx={{
            color: colorPublicMenuAccent,
            textTransform: "uppercase",
            letterSpacing: "0.2em",
            fontSize: { xs: 11, md: 12 },
            fontWeight: 600,
            mb: 1,
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        sx={{
          fontFamily: "Bogart-bold",
          color: colorPublicMenuText,
          fontSize: { xs: 32, md: 44 },
          lineHeight: 1.05,
        }}
      >
        {title}
      </Typography>
    </Box>

    <Box>
      {items.map((item) => (
        <MenuItemRow key={item.id} item={item} />
      ))}
    </Box>
  </Box>
);
